<axis-card id="outstandingCard">
  <axis-card-body>
    <h1 class="axis-h3">
      @if (isPipNonDigital()) {
        We have received your rejection of electronically selecting and signing your selection forms.
      } @else if (isPipEnabled) {
        PIP Complete - Continue to Your PIP Coverage Selections
      } @else {
        Thank you for Completing the PIP flow
      }
    </h1>
    @if (content) {
      <p
        class="_mtb-large"
        [innerHTML]="content"
      ></p>
    }

    @if (!isPipEnabled && note && !isPipNonDigital()) {
      <p>
        {{ note }}
      </p>
    }

    <button
      axis-button
      class="kind-secondary"
      [disabled]="downloadInProgress"
      (click)="downloadPIPDocuments()"
    >
      <axis-icon
        icon="download"
        font="custom"
      ></axis-icon>
      <span class="axis-btn-icon-text"> Download PIP Documents </span>
    </button>
    @if (downloadInProgress) {
      <axis-loading
        class="size-small"
        [isInline]="true"
        *ngIf="downloadInProgress"
      ></axis-loading>
    }
  </axis-card-body>
</axis-card>

@if (isPipEnabled && !this.pipBaseRulesService.isPlayground) {
      <div class="axis-btn-wrapper _ml-auto">
        <div class="axis-btn-wrapper-right">
          <button
            axis-button
            class="kind-primary"
            (click)="onContinue()"
          >
            <span class="axis-btn-icon-text">Continue</span>
          </button>
        </div>
      </div>
}
